import React from "react";
import { X } from "lucide-react";
import { Tooltip } from "@mui/material";

const CancelButton = (props) => {
	const { className, ...rest } = props;
	return (
		<>
			<Tooltip title='Close' placement='left-start' arrow>
				<X
					className={`absolute right-1 top-2 lg:right-2 lg:top-2 md:top-2 md:right-2 z-[99999] cursor-pointer  bg-white rounded-full  hover:text-primary ${className}`}
					{...rest}
				/>
			</Tooltip>
		</>
	);
};

export default CancelButton;
